import type { HelpFile } from '../../types/help'
import { AccessProfileFormTestIds } from '../../../testids/AccessProfileFormTestIds'

export const accessProfileFormHelp: HelpFile = {
  docPage: '/docs/governance/access-profiles',
  texts: {
    [AccessProfileFormTestIds.selectRiskLevel]: 'Risikostufe dieses Zugriffsprofils. Beeinflusst die Genehmigungsrichtlinie und die Zertifizierungsfrequenz — Profile mit hohem Risiko brauchen in der Regel eine strengere Prüfung.',
    [AccessProfileFormTestIds.selectReviewFrequency]: 'Wie oft dieses Profil rezertifiziert werden muss. Wähle einen Rhythmus, der zur Sensibilität des gewährten Zugriffs passt.',
    [AccessProfileFormTestIds.btnCancel]: null,
    [AccessProfileFormTestIds.btnSubmit]: null,
  },
}
